export type UserProfile = {
  firstName?: string;
  surName?: string;
  maskedDateOfBirth?: string;
  gender?: string;
  maskedEmail?: string;
  panNumber?: string;
  flatNo?: string;
  city?: string;
  state?: string;
  pincode?: string;
};

export type UserSessionObjectType = {
  userConsentActive: boolean | null;
  userId: string | null;
  accessToken: string | null;
  refreshToken: string | null;
  referenceId: string | null;
  accounts: any[] | null;
  templateType: string | null;
  pfmType: string | null;
  trackingId: string | null;
  isLoanJourneyEnabled: boolean;
  journeyType: string;
  tenant: string | null;
  sessionId: string | null;
  isWhiteListed: boolean;
  isNewUser: boolean;
  trendsVisible: boolean;
  existingUserJourneyStartedOnce: boolean;
  altJourney: string;
  altJourneyTheme: altJourneyTheme;
  sdkFlowSelection: boolean;
  mahindraTheme: string;
  maskedMobileNumber?: string | null;
  userProfile?: UserProfile | null;
};

export enum altJourneyTheme {
  YesGlory = 'YesGlory',
  YesGrandure = 'YesGrandure',
  YesPremia = 'YesPremia',
  YesFirst = 'YesFirst',
  YesPropsperity = 'YesPropsperity',
  YesPrivate = 'YesPrivate',
}

export enum altJourneyType {
  YESONLINE = 'YESONLINE',
}

export const TenantType = {
  PB: process.env.REACT_APP_TENANT_ID,
  YESBANK: process.env.REACT_APP_TENANT_ID_YB,
  MAHINDRA: process.env.REACT_APP_TENANT_ID_MAHINDRA,
  JFS: process.env.REACT_APP_TENANT_ID_JFS,
  AU: process.env.REACT_APP_TENANT_ID_AU,
};

export type UserDetailsType = {
  accessToken: string;
  refreshToken: string;
  userConsentActive: boolean;
  userId: string;
};
export type InitiateConsentResponseType = {
  redirectionUrl: string;
  referenceId: string;
};

export enum TransactionType {
  DEBIT,
  CREDIT,
}
export enum LOADERTYPE {
  GENERIC,
  DATALOADER,
}
